enum LandContractType {
    OilAndGas = 1,
    SolarLease,
    SurfaceWaiver,
    BatteryStorage,
    BrineLease
}

export default LandContractType;


// WEBPACK FOOTER //
// ./src/models/LandContractType.ts